import type { SVGProps } from "react";

const SvgBankBurgenlandSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="41.0 41.0 430.0 430.0"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path fill="#0F4294" d="M41 41h430v430H41z" />
    <path
      fill="#fff"
      d="m360.185 375.531-96.55.033c1.618-47.123-10.868-67.49-35.715-88.173-20.304-14.579-41.283-19.608-94.701-19.06v-32.399c9.519.569 17.961.347 28.865 0 25.779-.822 38.97-5.173 54.706-18.522 12.418-11.515 22.374-28.699 24.43-44.415 1.751-13.416 1.225-23.897-1.082-34.213l87.438-.201c.438 3.509.665 5.84.598 8.941-.268 14.703-2.818 22.672-7.288 33.019-8.386 19.68-24.93 34.218-38.013 43.272-5.022 3.473-11.264 7.282-20.69 11.711-7.829 3.52-15.282 6.217-23.168 8.574 36.364 2.713 67.665 17.804 89.787 40.332 21.056 21.421 31.749 49.469 31.749 80.854 0 3.892.01 6.471-.366 10.249"
    />
  </svg>
);
export default SvgBankBurgenlandSmallLogo;
